module.exports = "/_next/static/images/b982aa11345683a44cca7f88c3f9b510-yield.png.webp";